import type {ReactElement} from 'react';
import React from 'react';
import styles from './download-getty-requirement-info-box.module.scss';
import {Text, TextSize} from '@Components/text';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';

export function DownloadGettyRequirementInfoBox(): ReactElement | null {
  const {meetsGettyRequirements} = useDownloadPanelData();
  if (meetsGettyRequirements) {
    return null;
  }
  return (
    <div className={`_full-width spacing-p-t-2 text-center _fit-height spacing-p-b-2 spacing-p-r-3 spacing-p-l-3 radius-8 ${styles.container}`}>
      <Text className="content-danger" size={TextSize.XSMALL} val={window.i18next.t('pmwjs_getty_image_only_not_allowed')} />
    </div>
  );
}
